import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardArrows from 'src/app/model/product/ip-board/ip-board-arrows';
import IPBoardPlacement from 'src/app/model/product/ip-board/ip-board-placement';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-arrows',
  templateUrl: './ip-board-arrows.component.html',
  styleUrls: ['./ip-board-arrows.component.scss'],
})
export class IPBoardArrowsComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  @Input()
  ipBoard: IPBoard;
  @Input()
  multiple: boolean;
  @Input()
  index: number;
  @Input()
  client: boolean = false;
  @Output()
  update = new EventEmitter<any>();

  ipBoardPlacement: IPBoardPlacement;
  withArrows: boolean = false;

  private emitProductPlacementVariableChanged = new Subject<any>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ipBoardPlacement = <IPBoardPlacement>this.ipBoard.productPlacement;
    if (this.ipBoardPlacement.arrows == null) {
      this.ipBoardPlacement.arrows = new IPBoardArrows();
    }

    this.initializeWithArrows();

    this.addSubscription(
      this.emitProductPlacementVariableChanged,
      () =>
        this.projectDisplayObservableService
          .getProductPlacementVariableChangedSubscribable()
          .next(),
      GeneralHelper.noop,
      500
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.emitProductPlacementVariableChanged != null) {
      this.emitProductPlacementVariableChanged.complete();
      this.emitProductPlacementVariableChanged = null;
    }
  }

  private initializeWithArrows(): void {
    this.withArrows =
      (this.ipBoardPlacement.arrows.amountArrowsLeft != null &&
        this.ipBoardPlacement.arrows.amountArrowsLeft > 0) ||
      (this.ipBoardPlacement.arrows.amountArrowsRight != null &&
        this.ipBoardPlacement.arrows.amountArrowsRight > 0) ||
      !StringHelper.isEmpty(this.ipBoardPlacement.arrows.arrowsDesign) ||
      !StringHelper.isEmpty(this.ipBoardPlacement.arrows.arrowsLocation);

    if (!this.withArrows) {
      this.resetArrows();
    }
  }

  private resetArrows() {
    this.ipBoardPlacement.arrows.amountArrowsRight = null;
    this.ipBoardPlacement.arrows.amountArrowsLeft = null;
    this.ipBoardPlacement.arrows.arrowsDesign = null;
    this.ipBoardPlacement.arrows.arrowsLocation = null;
  }

  withArrowsChanged(): void {
    if (!this.withArrows) {
      this.resetArrows();
      this.update.emit();
      this.projectDisplayObservableService
        .getProductPlacementVariableChangedSubscribable()
        .next();
    } else {
      if (this.ipBoardPlacement.arrows.amountArrowsRight === null) {
        this.ipBoardPlacement.arrows.amountArrowsRight = 0;
      }
      if (this.ipBoardPlacement.arrows.amountArrowsLeft === null) {
        this.ipBoardPlacement.arrows.amountArrowsLeft = 0;
      }
    }
  }

  amountArrowsChanged(): void {
    this.update.emit();
    this.emitProductPlacementVariableChanged.next();
  }

  arrowsDesignChanged(value: string): void {
    this.ipBoardPlacement.arrows.arrowsDesign = value;
    this.update.emit();
    this.emitProductPlacementVariableChanged.next();
  }

  arrowsLocationChanged(value: string): void {
    this.ipBoardPlacement.arrows.arrowsLocation = value;
    this.update.emit();
    this.emitProductPlacementVariableChanged.next();
  }

  onArrowsDesignUpload() {
    this.update.emit();
    this.emitProductPlacementVariableChanged.next(undefined);
  }
}
